import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionVisual extends BaseModelAPI {
	static entity = 'productionqualityinspectionvisual';
	static entityName = 'productionqualityinspectionvisual';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.inspectionNumber = '';
			this.workOrderProcessDetailId = '';
			this.workOrderProcessDetail = {};
			this.workOrderExecutionDetailId = '';
			this.workOrderExecutionDetail = {};
			this.productionDate = '';
			this.partId = '';
			this.part = {};
			this.productionQualityInspectionVisualDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}